import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { BookOpen } from 'lucide-react';
import { guidesApi } from '@/api/endpoints/guides';

interface GuideLinksProps {
  locationSlug: string;
}

export function GuideLinks({ locationSlug }: GuideLinksProps) {
  const { data } = useQuery({
    queryKey: ['guides-by-location', locationSlug],
    queryFn: () => guidesApi.getByLocation(locationSlug),
    enabled: !!locationSlug,
    staleTime: 1000 * 60 * 60, // 1 hour
  });

  const guides = data?.guides;
  if (!guides || guides.length === 0) return null;

  return (
    <div className="mb-4">
      <h2 className="text-sm font-semibold text-[var(--color-muted)] mb-2">City Guides</h2>
      <div className="flex flex-col gap-2">
        {guides.map((guide) => (
          <Link
            key={guide.slug}
            to={`/guide/${guide.slug}`}
            className="flex items-start gap-3 rounded-lg bg-[var(--color-card)] p-3 border border-[var(--color-border)] hover:border-[var(--color-accent)] transition-colors"
          >
            <BookOpen className="h-4 w-4 mt-0.5 shrink-0 text-accent-primary" />
            <div className="min-w-0">
              <span className="text-sm font-medium text-[var(--color-text)]">{guide.title}</span>
              <p className="text-xs text-[var(--color-muted)] mt-0.5 line-clamp-1">{guide.metaDescription}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
